import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  CreatePayoutRequest,
  PayoutSummary,
  UpdateBankAccountRequest,
} from "@ticketnjoy/types";

import { ApiError, apiClient } from "@/lib/api-client";

export const payoutSummaryKey = ["payouts", "summary"] as const;

/** GET /payouts/summary — bakiye, banka hesabı, etkinlik kazançları, ödemeler (Owner). */
export function usePayoutSummaryQuery() {
  return useQuery<PayoutSummary, ApiError>({
    queryKey: payoutSummaryKey,
    queryFn: () => apiClient<PayoutSummary>("/payouts/summary"),
    staleTime: 30 * 1000,
  });
}

/** Tüm mutation'lar güncel özeti döner; cache doğrudan yazılır. */
function usePayoutMutation<TVars>(fn: (vars: TVars) => Promise<PayoutSummary>) {
  const qc = useQueryClient();
  return useMutation<PayoutSummary, ApiError, TVars>({
    mutationFn: fn,
    onSuccess: (data) => {
      qc.setQueryData(payoutSummaryKey, data);
      qc.invalidateQueries({ queryKey: ["audit"] });
    },
  });
}

export function useUpdateBankAccountMutation() {
  return usePayoutMutation((body: UpdateBankAccountRequest) =>
    apiClient<PayoutSummary>("/payouts/bank-account", { method: "PUT", body }),
  );
}

export function useRequestPayoutMutation() {
  return usePayoutMutation((body: CreatePayoutRequest) =>
    apiClient<PayoutSummary>("/payouts", { method: "POST", body }),
  );
}

export function useCancelPayoutMutation() {
  return usePayoutMutation((id: string) =>
    apiClient<PayoutSummary>(`/payouts/${id}/cancel`, { method: "POST" }),
  );
}
